





















import {
  defineComponent,
} from '@vue/composition-api'

export default defineComponent({

  props: {
    heading: { type: String, default: '' },
  },

  setup(props) {
    return { props }
  },
})

